import { __decorate } from "tslib";
import { namespace, State } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { uniq } from 'ramda';
const StatisticsStore = namespace('StatisticsStore');
let BranchStatisticsMixin = class BranchStatisticsMixin extends Vue {
    dates;
    setStatisticDates;
    data;
    ordering;
    total;
    loading;
    tableLoading;
    from;
    to;
    statistic;
    category_names;
    showSelectCategory = false;
    get categoryNamesFiltered() {
        return this.category_names.filter(category => !Object.keys(this.statistic).includes(category.title));
    }
    get showStatistic() {
        return !this.loading && Boolean(this.data && Object.keys(this.data).length);
    }
    get statisticTableData() {
        const typesData = Object.values(this.statistic);
        let typesAll = [];
        for (let i = 0; i < typesData.length; i++) {
            const type = Object.keys(typesData[i]);
            typesAll = typesAll.concat(type);
        }
        typesAll = uniq(typesAll);
        const types = typesAll.map(item => ({ key: item, type: item }));
        const data = [];
        const ids = Object.keys(this.statistic);
        for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
            const values = this.statistic[id];
            for (let j = 0; j < typesAll.length; j++) {
                if (!(typesAll[j] in values)) {
                    values[typesAll[j]] = 0;
                }
            }
            data.push({
                key: id,
                text: id,
                values: this.statistic[id],
            });
        }
        return {
            data,
            types,
        };
    }
};
__decorate([
    State(state => state.StatisticsStore.dates)
], BranchStatisticsMixin.prototype, "dates", void 0);
__decorate([
    StatisticsStore.Mutation('setStatisticDates')
], BranchStatisticsMixin.prototype, "setStatisticDates", void 0);
__decorate([
    Prop({ type: Object, required: true })
], BranchStatisticsMixin.prototype, "data", void 0);
__decorate([
    Prop({ type: Array, required: true })
], BranchStatisticsMixin.prototype, "ordering", void 0);
__decorate([
    Prop({ type: Number, required: true })
], BranchStatisticsMixin.prototype, "total", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], BranchStatisticsMixin.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], BranchStatisticsMixin.prototype, "tableLoading", void 0);
__decorate([
    Prop({ type: Date, required: true })
], BranchStatisticsMixin.prototype, "from", void 0);
__decorate([
    Prop({ type: Date, required: true })
], BranchStatisticsMixin.prototype, "to", void 0);
__decorate([
    Prop({ type: Object, required: true })
], BranchStatisticsMixin.prototype, "statistic", void 0);
__decorate([
    Prop({ type: Array, required: true })
], BranchStatisticsMixin.prototype, "category_names", void 0);
BranchStatisticsMixin = __decorate([
    Component
], BranchStatisticsMixin);
export default BranchStatisticsMixin;
;
